import Icons from "@/assets/icons/icons";

export const Values = {
  BookingLimit:10,
    discountType:{
      PERCENT:"PERCENT",
      FLAT:"FLAT"
    },
timeDuration:{
  _24hr:"24hr",
  _12hr:"12hr",
  _6hr:"6hr",
  custom:"custom"

},


     bookingSource : {
        APP: "APP",
        WEB: "WEB",
        DBL: "DBL",
        MARKETPLACE: "MARKETPLACE",
        ALL: "ALL",
        VENDOR: "VENDOR"
    },
    
  // API Constants
  sportsTypeEnum: [

    { name: 'Cricket', url: Icons.cricket },
    { name: 'Football', url: Icons.football },
    { name: 'Tennis', url: Icons.tabletennis },
    { name: 'Table Tennis', url: Icons.tabletennis },
    { name: 'Pickleball', url: Icons.Pickleball },
    { name: 'Volleyball', url: Icons.Volleyball },
    { name: 'Badminton', url: Icons.badminton },
    { name: 'Basketball', url: Icons.basketball },
    { name: 'swimming', url: Icons.swimming },

    { name: 'Boxing', url: Icons.boxing },

    // "Football",
    // "Cricket",
    // "Pickleball",
    // "Net Cricket",
    // "Badminton",
    // "Tennis",
    // "Basketball",
    // "Volleyball",
    // "Table Tennis",
    // "Squash",
    // "Hockey",
    // "Kabaddi",
    // "Handball",
    // "Boxing",
    // "Skating",
    // "Swimming",
    // "Gymnastics",
    // "Wrestling",
    // "Martial Arts",
    // "Snooker / Pool",
    // "Carrom",
    // "Chess",
    // "Other"
  ],
  API_TIMEOUT: 60,
  PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50],

  // auth keys
  jwtToken: 'JWtToken',

  AllRoleTypes: {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    AGENCY_ADMIN: 'AGENCY_ADMIN',
    AGENCY_SUPERVISOR: 'AGENT_SUPERVISOR',
    AGENT: 'AGENT',
  },

  edit: 'EDIT',
  resend_link: 'RESEND LINK',

  regex: {
    nameRegEx: '^[A-Za-z][A-Za-z ]*$',
    emailRegExp: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    numberRegExp: '^[0-9]+$ ',
    dateRegEx_DDMMYYY: '^(\\d{2})-(\\d{2})-(\\d{4})$',
    dateRegEx_YYYYMMDD: '^(\\d{4})-(\\d{2})-(\\d{2})$',
    mobileRegExp: '^[6-9][0-9]{9}$',
    last10NumRegExp: '\\d{10}$',
  },

   RENEWAL_WINDOW_DAYS_MONTHLY :7,
 RENEWAL_WINDOW_DAYS_YEARLY : 7,
  vendorSubscriptionsPlanId : {
    DBL_Monthly: "DBL-M-001",
    DBL_Yearly: "DBL-Y-001",
    DBL_LIFETIME: "DBL_LIFETIME",


    WEB_Monthly: "WEB-M-001",
    WEB_Yearly: "WEB-M-001",
  },
  
  billingCycleKeys : {
    monthly: "monthly",
    yearly: "yearly",
    lifetime:"lifetime"
  },
  vendorSubscriptionsPlanName : {
    directBooking: "directBooking",
    customWebsite: "customWebsite"
  },
  purchaseType:{
    onboarding: "onboarding" ,
    directBooking:"directBooking" ,
    website:"customWebsite",
    venueRecomendation:"venueRecomendation"
  },

  discountAppliedOn : {
    obj: {
        TOTAL: "TOTAL",
        PER_SLOT: "PER_SLOT",
    },

    enum: ["TOTAL", "PER_SLOT"],
},

 discountApplyType : {
    obj: {
        PERCENT: "PERCENT",
        FLAT: "FLAT",
        PERCENTAGE:"PERCENTAGE",
    },

    enum: ["PERCENT", "FLAT","PERCENTAGE"],
}

};
